import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentDetail, Demand } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { Country } from 'projects/Administration/src/app/business-entities/country.model';
import { DealerBrandViewModel } from 'projects/Administration/src/app/business-entities/dealer-brand-view-model';
import { DealerDetailsListViewModel } from 'projects/Administration/src/app/business-entities/dealer-details-view-model';
import { DealerOpeningHoursViewModel } from 'projects/Administration/src/app/business-entities/dealer-opening-hours-view-model';
import { DealerViewModel } from 'projects/Administration/src/app/business-entities/dealer-view-model';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { DocumentService } from 'projects/Administration/src/app/business-services/document.service';
import { PdfType, WorkOrderStatus } from 'projects/Autofacets-Core/src/app/utils/enums';
import * as Enums from '../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { DisplayServiceDetailsInvoice, InvoiceDemandLists, ServiceDetailsInvoice } from './../../../../../business-entities/service-detail-invoice-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { saveAs } from 'file-saver';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';


@Component({
  selector: 'app-pdf-view',
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.css']
})
export class PDFViewComponent implements OnInit {
  @Input() isDownloadOrder: boolean = false;
  @Input() isWithoutPrice: boolean = false;
  code: string;
  contactDetails: AppointmentDetail = {
    address: "",
    bookedDate: null,
    city: "",
    color: "",
    companyModel: "",
    contactInfo: "",
    country: "",
    state: "",
    createdDate: null,
    customerName: "",
    customerNo: "",
    dealerName: "",
    email: "",
    engineNumber: "",
    homePhoneNo: "",
    kilometer: 0,
    previousKilometer: 0,
    licensePlate: "",
    mechanicId: 0,
    mobileNo: "",
    mobileCode: "",
    customerMobileCode: "",
    modelName: "",
    officePhoneNo: "",
    plannedMechanics: "",
    pastPlannedMechanics: "",
    postCode: "",
    registrationDate: "",
    singlePhoneNo: "",
    nomineeMobileCode: "",
    updatedDate: null,
    vehicleId: "",
    rentalVehicleId: "",
    price: null,
    vehicleType: "",
    workOrderNo: "",
    year: 1999,
    discount: 0,
    isPickUpDropOffService: false,
    pickUpDateTime: null,
    chassisNo: "",
    fuelType: "",
    companyMakeName: "",
    companyMakeCode: "",
    isAutoKey: false,
    isKeyDrop: false,
    isCheckIn: false,
    rentalLicensePlate: "",
    isCheckInDoneByCustomer: false,
    rentalCompanyMakeName: "",
    createdBy: "",
    updatedBy: "",
    sourceCreation: "",
    ownerName: "",
    isCarRemainInWorkshop: false,
    inspectionNextDate: null,
    inspectionPrevDate: null,
    dmsRegistrationDate: null,
    dmsRegistrationLastDate: null,
    campaignServiceId:0,
    campaignServiceText:"",
    serviceContractCustomer:null
  };
  id: number = 2;
  price: number = 0;
  // priceWithTax: number = 0;
  totalPriceAfterDiscount: number = 0
  taxPrice: number = 0;
  createdDate: any;
  bookedDate: any;
  salesPrice: number = 0;
  salesPriceWithVAT: number = 0;
  VATPrice: number = 0
  personalMaterialTax: number = 0;
  dealerAllBrands: DealerBrandViewModel[];
  dealerOpeningHours: DealerOpeningHoursViewModel[];
  dealerDetailsListViewModel: DealerDetailsListViewModel;
  dealerDetails: DealerViewModel = {
    //adUserId: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    dealerId: "",
    dealershipsId: 0,
    locationName : '',
    email: "",
    franchiseId: 0,
    id: 0,
    isActive: true,
    isActiveForWidget: false,
    keyLocation: true,
    vehiclePickupDropoffService: true,
    name: "",
    landline: 12,
    mobile: 154,
    onlinePayment: true,
    pincode: "",
    state: "",
    unitPrice: '45',
    customerWaitingLimit: 0,
    bankAccountNumber: "",
    companyNumber: "",
    vatNumber: "",
    ssmDealerId:"",
    sstDealerId:"",
    transportSolutionId:''
  };
  demList: Demand[] = [];
  countryDropdown: Country[] = [];
  TodayDate: Date;
  currency: string;
  isView: boolean = false;
  // serviceDetail: AppointmentServiceDetails;
  serviceDetail: ServiceDetailsInvoice;
  invoiceData: DisplayServiceDetailsInvoice[] = [];
  DiscountWithPrecision: any;
  showMinusRoundOff: boolean = false;
  roundOff: number;
  appointmentDetails: AppointmentList;
  featureList: Features[] = [];
  isShowTax: boolean = false;
  @ViewChild('content') content: ElementRef;

  constructor(private readonly appointmentService: AppointmentService,
    public editAppointmentService: EditAppointmentService,
    private readonly spinner: NgxSpinnerService,
    private readonly dealerBusinessService: DealerBusinessService,
    public settingService: SettingService,
    public workOrderService: AppointmentWorkOrderService,
    private readonly datepipe: DatePipe,
    private readonly toastr: ToastrService,
    private readonly cookieservice: CookieService,
    private readonly secureStorage: SecureStorage,
    private readonly documentService: DocumentService,
    private readonly translate: TranslateService,
    private readonly activeModal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    if (this.isDownloadOrder) {

    } else {
      this.getFeatures();
      this.GetAll();
    }

    this.showMinusRoundOff = false;
    this.TodayDate = new Date();
  }

  async getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList && this.featureList.length > 0) {
        this.isShowTax = this.featureList.find(x => x.featureCode === Enums.FeatureCode.Tax)?.isActive
      }
    }
  }

  async DownloadDeliveryNote() {
    let model = {
      PdfType: this.appointmentService.pdfTypeIndex,
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      AppointmentId: this.appointmentDetails.id,
      AppointmentGuid: this.appointmentDetails.appointmentGuid,
      WorkOrderNo: this.appointmentDetails.workOrderNo,
      DealerId: this.appointmentDetails.dealerId
    };
    this.spinner.show();
    this.documentService.DownloadDeliveryNote(model).toPromise().then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          let blob = Utility.base64toBlob(res.responseObject.fileContents, "application/pdf;charset=utf-8");
          saveAs(blob, res.responseObject.fileDownloadName);
          /* this code to open in new window
           var fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
            */
          this.activeModal.dismiss('Cross click');
        } else {
          let error: string = "";
          if (res.responseMessage === 'data') {
            error = this.translate.instant("lblDocumentDetailNotFound");
          }
          else {
            error = this.translate.instant("lblPdfGenerateError");
          }
          this.toastr.error(error);
        }
      }, (_err) => {
        let error = this.translate.instant("lblPdfGenerateError");
        this.toastr.error(error);
      },).finally(() => {
        this.spinner.hide();
      });
  }

  async generatePdf() {
    this.id = this.appointmentService.pdfTypeIndex;
    if (this.id > 0) {
      if (this.id == 1 || this.id == 2 || this.id == 3) {
        this.DownloadDeliveryNote();
      }
      else {
        this.spinner.show(undefined,
          {
            type: 'ball-clip-rotate',
            size: 'large',
            bdColor: 'rgba(255,250,250,0.9)',
            color: 'black',
            fullScreen: true
          });

        setTimeout(() => {
          this.isView = true;
          let data = document.getElementById('content');
          html2canvas(data,
            { logging: false }
          ).then(_canvas => {
            // Few necessary setting options
            const pdf = new jsPDF('p', 'pt', 'a4'); // A4 size page of PDF
            this.isView = false;
            switch (this.id) {
              case 1:
                pdf.setProperties({
                  title: 'OrderConfirmationWithPrice',
                });
                break;
              case 2:
                pdf.setProperties({
                  title: 'OrderConfirmationWithoutPrice',
                });
                break;
              case 3:
                pdf.setProperties({
                  title: 'OfferWithPrice',
                });
                break;
              case 4:
                pdf.setProperties({
                  title: 'Invoice',
                });
                break;
            }
            pdf.html(this.content.nativeElement, {
              margin: 10,
              callback: (pdf) => {
                this.activeModal.dismiss('Cross click')
                switch (this.id) {
                  case 1:
                    pdf.save('OrderConfirmationWithPrice' + this.editAppointmentService.appointmentDetails.id);
                    break;
                  case 2:
                    pdf.save('OrderConfirmationWithoutPrice' + this.editAppointmentService.appointmentDetails.id);
                    break;
                  case 3:
                    pdf.save('OfferWithPrice' + this.editAppointmentService.appointmentDetails.id);
                    break;
                  case 4:
                    pdf.save('Invoice' + this.editAppointmentService.appointmentDetails.id);
                    break;
                }
                this.spinner.hide();
                this.activeModal.dismiss('Cross click')
              }
            })
          });
        }, 1000);
      }
    }
    else {
      let error = this.translate.instant("lblPlzSelectPdfType")
      this.toastr.error(error)
    }
  }

  async GetAll() {
    await this.GetAppointmentDetail(this.editAppointmentService.appointmentDetails.id);
    await this.GetServiceDetail();
    await this.getDealerDetails();
  }

  async GetServiceDetail() {
    this.invoiceData = [];
    let pdfTypeId: number = PdfType.OrderConfirmationWithPrice;
    if (this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.InvoiceReady
      || this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.InvoicePaid ||
      this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.Closed) {
      pdfTypeId = PdfType.Invoice;
    }
    await this.appointmentService.GetServicDetailForInvoice(this.editAppointmentService.appointmentDetails.appointmentGuid, pdfTypeId).then(data => {
      if (data.responseObject?.errorCount > 0) {
        this.serviceDetail = {
          invoiceDemandLists: [],
          invoiceJobLists: [],
          invoiceJobDetailsLists: [],
          invoicePriceLists: null,
          filePath: null
        }

      }
      else {
        this.serviceDetail = data.responseObject;
        if (this.serviceDetail.invoiceDemandLists && this.serviceDetail.invoiceDemandLists.length > 0) {
          this.serviceDetail.invoiceDemandLists.forEach(demand => {
            let joblist = this.serviceDetail.invoiceJobLists.filter(x => x.demandNo === demand.demandNo);
            let jobDetailList = this.serviceDetail.invoiceJobDetailsLists.filter(x => x.demandNo === demand.demandNo);
            if (joblist && jobDetailList) {
              let demandObj: InvoiceDemandLists;
              let data: DisplayServiceDetailsInvoice = {
                invoiceDemand: demandObj,
                invoiceJobLists: [],
                invoiceJobDetailsLists: []
              }
              data.invoiceDemand = demand;
              data.invoiceJobLists = joblist;
              data.invoiceJobDetailsLists = jobDetailList;
              this.invoiceData.push(data);
            }
          });
        }
        if (this.serviceDetail.invoicePriceLists[0].roundOff < 0) {
          this.showMinusRoundOff = true;
          this.roundOff = Math.abs(this.serviceDetail.invoicePriceLists[0].roundOff);
        }
        else {
          this.roundOff = this.serviceDetail.invoicePriceLists[0].roundOff;
        }
      }
    })

  }

  async GetAppointmentDetail(Id: number) {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.appointmentService.GetAppointmentDetail(Id, language).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.contactDetails = result.responseObject;
        this.createdDate = this.contactDetails.createdDate;
        this.contactDetails.createdDate = this.createdDate;
        this.bookedDate = this.contactDetails.bookedDate;
        this.contactDetails.bookedDate = this.bookedDate;
        if (this.contactDetails.discount)
          this.DiscountWithPrecision = this.contactDetails.discount.toFixed(2);
        if (this.contactDetails.pickUpDateTime) {
          //conver from utc to local
          let latest_date = this.datepipe.transform(this.contactDetails.pickUpDateTime, 'yyyy-MM-dd HH:mm:ss');
          let yourDate: Date = new Date(latest_date + ' UTC');
          this.contactDetails.pickUpDateTime = yourDate;
        }
        this.cdr.detectChanges();
      }
    },);
  }

  async getDealerDetails() {
    this.spinner.show();
    await this.dealerBusinessService.getDealerDetails(this.editAppointmentService.appointmentDetails.dealerId).then((response) => {
      this.dealerDetailsListViewModel = response;
      this.dealerDetails = this.dealerDetailsListViewModel.dealerDetails;
      this.dealerAllBrands = this.dealerDetailsListViewModel.dealerBrandList;
      this.dealerOpeningHours = this.dealerDetailsListViewModel.dealerHours;
      if (this.dealerDetails.country) {
        let countryOfDealer = this.countryDropdown.find(country => country.countryName === this.dealerDetails.country)
        this.dealerDetails.country = countryOfDealer ? countryOfDealer.id.toString() : '-1';
      } else {
        this.dealerDetails.country = '-1';
      }
      this.spinner.hide();
    });
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async printPdf(type) {
    let BillToCustomer = this.appointmentService?.billToCustomerNo?.length != 0 ? this.appointmentService?.billToCustomerNo : ""
    if (this.empty(BillToCustomer)) {
      let error = this.translate.instant("lblPleaseSelectPayer")
      this.toastr.error(error)
      return;
    }
    let model = {
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      WorkOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      DealerId: this.editAppointmentService.appointmentDetails.dealerId,
      BillToCustomer: BillToCustomer,
      IsWithoutPrice : this.isWithoutPrice
    };
    this.spinner.show();

    if (this.appointmentService.documentTypeId == 0) {
      this.documentService.DownloadOrderDocument(model).toPromise().then(
        (res: any) => {
          if (res && res.responseCode == 200) {
            let blob = Utility.base64toBlob(res.responseObject.fileContents, "application/pdf;charset=utf-8");
            if (type == 1) {
              saveAs(blob, res.responseObject.fileDownloadName);
            } else {
              var fileURL = URL.createObjectURL(blob);
              window.open(fileURL);
            }
            this.activeModal.dismiss('Cross click');
          } else {
            let error: string = "";
            switch (res.responseMessage) {
              case 'data':
                error = this.translate.instant("lblDocumentDetailNotFound");
                break;
              default:
                error = this.translate.instant("lblPdfGenerateError");
                break;
            }
            this.toastr.error(error);
          }
        }, (_err) => {
          let error = this.translate.instant("lblPdfGenerateError");
          this.toastr.error(error);
        },).finally(() => {
          this.spinner.hide();
        });
    } else {
      this.documentService.DownloadWarrantyDocument(model).toPromise().then(
        (res: any) => {
          if (res && res.responseCode == 200) {
            let blob = Utility.base64toBlob(res.responseObject.fileContents, "application/pdf;charset=utf-8");
            if (type == 1) {
              saveAs(blob, res.responseObject.fileDownloadName);
            } else {
              var fileURL = URL.createObjectURL(blob);
              window.open(fileURL);
            }
            this.activeModal.dismiss('Cross click');
          } else {
            let error: string = "";
            switch (res.responseMessage) {
              case 'data':
                error = this.translate.instant("lblDocumentDetailNotFound");
                break;
              case 'demand':
                error = this.translate.instant("lblWarrantyDemandNotFound");
                break;
              default:
                error = this.translate.instant("lblPdfGenerateError");
                break;
            }
            this.toastr.error(error);
          }
        }, (_err) => {
          let error = this.translate.instant("lblPdfGenerateError");
          this.toastr.error(error);
        },).finally(() => {
          this.spinner.hide();
        });
    }
  }
}
